import { combineReducers } from 'redux'

import token from './token/reducer'
import order from './order/reducer'
import footer from './footer/reducer'

const rootReducer = combineReducers({
  token,
  order,
  footer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/rootReducer.js